import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { FeatureFlag } from "PFTypes";
import { useEffect } from "react";

export const useChameleonProfilePayload = () => {
  const { data: currentProfile } = useCurrentProfile();
  const { data: currentAccount } = useCurrentAccount();
  const isChameleonEnabled = useIsFeatureEnabled(FeatureFlag.Chameleon);

  useEffect(() => {
    if (!isChameleonEnabled || !window.chmln || !currentAccount.id) {
      return;
    }

    if (currentProfile.id) {
      window.chmln.identify(currentProfile.id, {
        role: currentProfile.roles[0],
        permission_group: currentProfile.permissionsGroup.name,
        company_name: currentAccount.full_domain,
        grade: currentProfile.grade?.[0]?.value,
        location: currentProfile.location?.[0]?.value,
        service_line: currentProfile.serviceLine?.[0]?.value
      });
    } else {
      try {
        const uid = document.cookie.match(/\bvisitor-uid=([a-z0-9-]+)(;|$)/)![1];
        window.chmln.identify(uid, { visitor: true });
      } catch {}
    }
  }, [currentProfile.id, currentAccount.id]);
};
